const avocadoPulpData = {
  hero_section: {
    title: "Premium Avocado Pulp Collection",
    description: "100% Natural • No Preservatives • Rich in Healthy Fats",
    src: "videos/avocado-processing.webm",
  },
  description: {
    title: "Premium Avocado Pulp Collection",
    main_description:
      "Discover our range of 100% natural avocado pulp, crafted from the finest avocados to preserve the authentic creamy texture and nutritional benefits.",
    segment_description:
      "Perfect for smoothies, health foods, and premium culinary applications.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Avocado Pulp",
    description: "Our avocado pulp delivers rich, creamy texture with exceptional nutritional value. Packed with healthy fats and nutrients, it's perfect for health-conscious food applications and premium culinary uses.",
    image: "New-Images/Avocado.png",
    mainFeatures: [
      "Rich in healthy monounsaturated fats",
      "High nutritional value",
      "Creamy, smooth texture",
      "Perfect for health foods",
      "Premium quality processing",
      "Consistent quality and freshness"
    ],
    nutrition: {
      servingSize: "100g",
      calories: "190",
      fat: "12g (Healthy fats)",
      carbs: "16g (Sugar: 16g, Added: 15g)",
      fiber: "6g",
      protein: "3g",
      sodium: "0mg",
      potassium: "320mg"
    }
  },
  products: [
    {
      id: "1",
      name: "Premium Avocado Pulp",
      image: "New-Images/Avocado.png",
      features: [
        "Rich creamy texture",
        "High in healthy fats",
        "Premium quality",
        "Perfect for smoothies"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Avocado Pulp Excellence",
    description: "Our avocado pulp is processed from the finest handpicked avocados using advanced processing techniques. We maintain strict quality control to ensure consistent texture, nutritional value, and freshness in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Health Food Industry",
    subline: "From smoothies to gourmet foods – premium nutrition in every application!",
    description:
      "Ideal for health food manufacturers, smoothie bars, gourmet restaurants, and food service providers who demand premium quality and nutritional excellence.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "smoothie-applications.webp",
      title: "Smoothie Applications",
      description:
        "Perfect for premium smoothies, health drinks, and nutritional beverages with rich creamy texture.",
    },
    {
      id: 2,
      image: "gourmet-applications.webp",
      title: "Gourmet Applications",
      description:
        "Ideal for gourmet foods, premium sauces, and high-end culinary applications requiring authentic avocado taste.",
    },
    {
      id: 3,
      image: "health-applications.webp",
      title: "Health Food Service",
      description:
        "Excellent for health-focused restaurants, wellness centers, and nutrition-conscious food service providers.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural avocado goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Nutritional Excellence",
      image: "nutritional-excellence.webp",
      title: "Nutritional Excellence",
      description:
        "Preserves natural nutrients and healthy fats for maximum health benefits",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Avocado Pulp",
    description: "Discover the perfect blend of quality, nutrition, and authentic flavors that make our avocado pulp the preferred choice for health-conscious food manufacturers worldwide.",
  },
};

export default avocadoPulpData;
